import { Injectable } from '@angular/core';

@Injectable()
export class UnsupportedBrowserService {
  public DISMISS = 'dismiss';

  public showUnsupportedBrowserWarning(
    supportedBrowser: boolean,
    isDismissed: boolean
  ): boolean {
    return !supportedBrowser && !isDismissed;
  }

  public isSupportedBrowser(isChrome: boolean, isSafari: boolean): boolean {
    return isChrome || isSafari;
  }

  public dismiss(): void {
    sessionStorage.setItem('dismissUnsupportedBrowser', this.DISMISS);
  }

  public isDismissed(): boolean {
    return sessionStorage.getItem('dismissUnsupportedBrowser') === this.DISMISS;
  }
}
